import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";
import { Link } from "react-router-dom";

const Safety = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="Safety Protocols" 
        description="PPE requirements and preventive safety practices"
      >
        <section className="space-y-6">
          <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
            <p className="text-muted-foreground">
              Following safety protocols protects you and our customers, and qualifies you for the{" "}
              <strong className="text-foreground">$250 safety bonus</strong> awarded every 6 months 
              to technicians with zero safety incidents.
            </p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-sm text-muted-foreground">
              🚨 For emergency response procedures (spills, injuries, incidents), see{" "}
              <Link to="/wiki/procedures/emergency" className="text-primary hover:underline font-medium">
                Emergency Protocols
              </Link>
            </p>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Personal Protective Equipment (PPE)</h2>
          <p className="text-muted-foreground mb-4">Required PPE for all technicians:</p>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="border border-border rounded-lg p-4">
              <h3 className="font-medium mb-2">Always Required</h3>
              <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
                <li>Closed-toe shoes with slip-resistant soles</li>
                <li>Sunscreen and hat for sun protection</li>
              </ul>
            </div>
            <div className="border border-border rounded-lg p-4">
              <h3 className="font-medium mb-2">When Handling Chemicals</h3>
              <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
                <li>Safety glasses</li>
                <li>Chemical-resistant gloves</li>
              </ul>
            </div>
            <div className="border border-border rounded-lg p-4">
              <h3 className="font-medium mb-2">Special Situations</h3>
              <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
                <li>Reflective vest near roadways</li>
                <li>Respirator for enclosed equipment rooms</li>
              </ul>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Chemical Handling Basics</h2>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Always add chemicals to water, never water to chemicals</li>
            <li>Never mix different chemicals together</li>
            <li>Keep chemicals in original labeled containers</li>
            <li>Ensure proper ventilation when adding chemicals</li>
            <li>Secure containers to prevent spills during transport</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Electrical Safety</h2>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Never service equipment with wet hands</li>
            <li>Turn off equipment at breaker before servicing</li>
            <li>Inspect cords for damage before use</li>
            <li>Never bypass safety switches or covers</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Slip, Trip & Fall Prevention</h2>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Walk carefully on wet pool decks</li>
            <li>Watch for uneven surfaces and obstacles</li>
            <li>Keep work area organized and clear</li>
            <li>Alert customers to slip hazards you create</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Heat Illness Prevention</h2>
          <div className="border border-border rounded-lg p-4">
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Drink water throughout the day (1 cup per hour minimum)</li>
              <li>Take breaks in shade during extreme heat</li>
              <li>Recognize signs: dizziness, nausea, excessive sweating</li>
              <li className="text-foreground font-medium">If you feel unwell, stop work and call for help</li>
            </ul>
          </div>

          <div className="bg-destructive/10 border border-destructive rounded-lg p-4 mt-8">
            <p className="font-semibold text-destructive mb-2">Remember</p>
            <p className="text-sm text-muted-foreground">
              No shortcut is worth risking your health. If something feels unsafe, stop and contact management.
            </p>
          </div>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default Safety;
